import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateProfile, changePassword, deleteAccount } from './profileApi.js';
import { logout, selectUser, setUser } from '../Auth/authSlice';

import './Profile.css';


const Profile = () => {
  const user = useSelector(selectUser);
  const dispatch = useDispatch();

  const [name, setName] = useState(user?.name || '');
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [profileMessage, setProfileMessage] = useState('');
  const [passwordMessage, setPasswordMessage] = useState('');
  const [deleteMessage, setDeleteMessage] = useState('');

  const handleSaveProfile = async () => {
    if (!name.trim()) {
      setProfileMessage('Имя не может быть пустым');
      return;
    }
    try {
      const updatedUser = await updateProfile({ name, email: user.email });

      dispatch(setUser(updatedUser));
      setProfileMessage('Профиль успешно обновлён');
    } catch (error) {
      setProfileMessage('Ошибка при обновлении профиля');
    }
  };

  const handleSavePassword = async () => {
    if (!currentPassword || !newPassword || !confirmPassword) {
      setPasswordMessage('Пожалуйста, заполните все поля');
      return;
    }
    if (newPassword !== confirmPassword) {
      setPasswordMessage('Новый пароль и подтверждение не совпадают');
      return;
    }
    try {
      await changePassword({ currentPassword, newPassword, email: user.email });

      setPasswordMessage('Пароль успешно изменён');
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } catch (error) {
      setPasswordMessage('Ошибка при изменении пароля');
    }
  };

  const handleDeleteAccount = async () => {
    if (!window.confirm('Вы уверены, что хотите удалить аккаунт? Это действие необратимо.')) return;
    try {
      await deleteAccount({ email: user.email });

      dispatch(logout());
      setDeleteMessage('Аккаунт удалён');
      // можно перенаправить пользователя, например:
      // navigate('/auth');
    } catch (error) {
      setDeleteMessage('Ошибка при удалении аккаунта');
    }
  };

  if (!user) return <p>Загрузка...</p>;

  return (
    <div className="profile-container">
      <h2>Профиль</h2>

      <div className="profile-section">
        <label>
          Имя
          <input
            type="text"
            value={name}
            onChange={e => setName(e.target.value)}
            placeholder="Введите имя"
          />
        </label>
        <button onClick={handleSaveProfile}>Сохранить</button>
        {profileMessage && <p className="message">{profileMessage}</p>}
      </div>

      <div className="profile-section">
        <p>Email: <strong>{user.email}</strong></p>
      </div>

      <div className="profile-section">
        <label>
          Текущий пароль
          <input
            type="password"
            value={currentPassword}
            onChange={e => setCurrentPassword(e.target.value)}
            placeholder="Введите текущий пароль"
          />
        </label>

        <label>
          Новый пароль
          <input
            type="password"
            value={newPassword}
            onChange={e => setNewPassword(e.target.value)}
            placeholder="Введите новый пароль"
          />
        </label>

        <label>
          Подтвердить пароль
          <input
            type="password"
            value={confirmPassword}
            onChange={e => setConfirmPassword(e.target.value)}
            placeholder="Подтвердите новый пароль"
          />
        </label>

        <button onClick={handleSavePassword}>Сохранить</button>
        {passwordMessage && <p className="message">{passwordMessage}</p>}
      </div>

      <div className="profile-section delete-account">
        <p>
          <strong>Удалить аккаунт</strong><br />
          После удаления Вашей учётной записи все её ресурсы и данные будут удалены без возможности восстановления. Перед удалением учётной записи загрузите данные и информацию, которую хотите сохранить.
        </p>
        <button className="btn-delete" onClick={handleDeleteAccount}>Удалить аккаунт</button>
        {deleteMessage && <p className="message">{deleteMessage}</p>}
      </div>
    </div>
  );
};

export default Profile;
